import * as CronofyElements from "cronofy-elements";
import { useEffect } from "react";
import { useState } from "react";

export const DateTimePickerWrapper = ({ options }) => {
  // //console.log(options);
  const [element, setElement] = useState(null);

  useEffect(() => {
    if (!element) {
      setElement(CronofyElements.DateTimePicker(options));
    }
  }, []);

  useEffect(() => {
    if (element) {
      element.update(options);
    }
  }, [options]);

  return <div id={options.target_id} />;
};
